import React from 'react'

/**
 * Segmented toggle of the create-event modal (mock `.cev-seg`): real radio inputs under a
 * styled span, the checked one in solid ink. `stacked` is the category variant (`.cev-seg.cat`),
 * which goes to one column under 480px.
 */
export default function SegmentedChoice({
    name,
    value,
    options,
    onChange,
    stacked = false,
    labelledBy,
    describedBy,
    invalid = false,
    // Ref on the first radio: where the form sends focus when the group is in error.
    firstRef,
}) {
    return (
        <div
            className={`cev-seg${stacked ? ' cat' : ''}`}
            role="radiogroup"
            aria-labelledby={labelledBy}
            aria-describedby={describedBy}
            aria-invalid={invalid || undefined}
        >
            {options.map(({ value: optionValue, label, Icon }, index) => (
                <label key={optionValue}>
                    <input
                        type="radio"
                        name={name}
                        value={optionValue}
                        checked={value === optionValue}
                        onChange={() => onChange(optionValue)}
                        ref={index === 0 ? firstRef : undefined}
                    />
                    <span>
                        {Icon && <Icon />}
                        <span>{label}</span>
                    </span>
                </label>
            ))}
        </div>
    )
}
